module.exports = "<div #graphContainer>\n  <svg #graph></svg>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/shot-image/shots-graph/shots-graph.component.html
// module id = ./src/app/projects/project/shot-image/shots-graph/shots-graph.component.html
// module chunks = main